export enum ResultCode {
    USERNAME_EXISTS = 'USERNAME_EXISTS',
    USER_NOT_EXIST = 'USER_NOT_EXIST',
    LOGIN_FAILED = 'LOGIN_FAILED',
    USER_NOT_LOGGED_IN = 'USER_NOT_LOGGED_IN',
    OK = 'OK'
}